import User from './class/user'
import LocalStorage from './class/local_storage'

export default {
  AUTH_SET (state, on) {
    state.authenticated = on === true
  },

  SET_RMQHINT (state, hint) {
    if (hint === 3) {
      state.rmqhint = 1
    } else {
      state.rmqhint = hint > 0 ? state.rmqhint ^ 2 : hint
    }
  },

  SET_SIPUAONLINE (state, status) {
    state.sipuaOnline = status
  },

  REGISTER_SET (state, data) {
    const expire = parseInt(data.expires)
    if (isNaN(expire)) {
      return
    }
    if (expire === 0) {
      User.setUserOffline(state.users.buddies, data.touser)
    } else {
      User.setUserOnline(state.users.buddies, data.touser)
    }
  },

  SET_COMPACT_VIEW (state, enabled) {
    LocalStorage.setUsersCompactView(enabled)
    state.users.compactView = enabled
  },

  SET_SUPER_LIGHT_VIEW (state, enabled) {
    LocalStorage.setUsersSuperLightView(enabled)
    state.users.superLightView = enabled
  },

  SET_SUPER_LIGHT_SIZE (state, size) {
    LocalStorage.setUsersSuperLightSize(size)
    state.users.superLightSize = size
  },

  SET_BUDDIES_SORT (state, sort) {
    LocalStorage.setUsersSort(sort)
    state.users.sort = sort
  },

  CALL_PANEL_INITIALIZED (state, initialized) {
    state.callPanelInitialized = initialized
  }
}
